export function mod(a: number, n: number): number {
  if (n <= 0) throw new Error('mod: modulus must be positive');
  const r = a % n;
  return r < 0 ? r + n : r;
}

export function modAdd(a: number, b: number, n: number): number {
  return mod(mod(a, n) + mod(b, n), n);
}

export function modMul(a: number, b: number, n: number): number {
  return mod(mod(a, n) * mod(b, n), n);
}

export function modPow(a: number, k: number, n: number): number {
  if (n === 1) return 0;
  let result = 1;
  let base = mod(a, n);
  let exp = k;
  while (exp > 0) {
    if (exp % 2 === 1) {
      result = mod(result * base, n);
    }
    exp = Math.floor(exp / 2);
    base = mod(base * base, n);
  }
  return result;
}

export interface ExtendedEuclidean {
  x: number;
  y: number;
  gcd: number;
}

export function extendedEuclidean(a: number, b: number): ExtendedEuclidean {
  if (b === 0) return { x: 1, y: 0, gcd: a };
  const { x: x1, y: y1, gcd: g } = extendedEuclidean(b, a % b);
  return { x: y1, y: x1 - Math.floor(a / b) * y1, gcd: g };
}

export function modInverse(a: number, n: number): number | null {
  const { x, gcd: g } = extendedEuclidean(mod(a, n), n);
  if (g !== 1) return null;
  return mod(x, n);
}

export function quadraticResidues(n: number): Set<number> {
  const out = new Set<number>();
  for (let i = 0; i < n; i += 1) {
    out.add(mod(i * i, n));
  }
  return out;
}
